/**
 * Upload file size limit (single place for all upload flows).
 */
export const MAX_UPLOAD_FILE_SIZE_BYTES = 256 * 1024 * 1024 // 256MB

/** User-facing error message when file exceeds size limit. */
export const UPLOAD_FILE_SIZE_ERROR_MESSAGE = 'ファイルサイズは256MB以下にしてください'
